// We only need to import the modules necessary for initial render
import React from 'react'
import RootLayout from '../layouts/RootLayout/RootLayout'
import Main from './Main/containers/MainContainer'
import LoginView  from './Login/components/LoginView'

//import CounterRoute from './Counter'
// import Counter from './Counter/components/Counter'
import {asyncComponent, privateComponent} from '../helpers/generateComponents'
import {injectReducer} from "../store/reducers";

export const createRoutes = (store) => ([
  {
    component: RootLayout,
    routes: [
      {
        path: '/',
        exact: true,
        component: privateComponent(Main),
        routes: [

        ]
      }
      // {
      //   path: '/counter',
      //   exact: true,
      //   component: asyncComponent(() => {
      //       import('./Counter/modules/counter').then(module => {
      //         injectReducer(store, {key: 'counter', reducer: module.default})
      //       });
      //
      //       return import('./Counter/containers/CounterContainer').then(module => module.default)
      //     }
      //   )
      // }
    ]
  }
]);


export default createRoutes



// WEBPACK FOOTER //
// ./src/routes/index.js